import { makeStyles } from 'tss-react/mui';

const useStylesTableRowAddNewItem: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  tableRowAddNewItem: {
    boxSizing: 'content-box',
    marginLeft: '10px !important',
    paddingTop: '15px !important',
    paddingBottom: '16px !important',
    '& > td': {
      padding: '10px 20px !important',
    },
  },
  tableCellSticky: {
    borderRight: 'none !important',
  },
}));

export default useStylesTableRowAddNewItem;
